import { Badge } from "./ui";
import { BOOKING_STATUS_LABEL, DEPARTMENT_LABEL, ENQUIRY_STATUS_LABEL, JOB_STATUS_LABEL, QUOTE_STATUS_LABEL, type JobStatus } from "../shared/labels";
import { penceToPoundsString } from "../shared/money";
import { formatDateUK } from "../shared/dates";
import { INVOICE_SETTLEMENT_LABEL, invoiceSettlement } from "../shared/invoiceStatus";

type Tone = "blue" | "green" | "amber" | "red" | "navy" | undefined;

const JOB_TONE: Record<JobStatus, Tone> = {
  booked: undefined, checked_in: "blue", awaiting_approval: "amber", in_progress: "navy", waiting_parts: "amber", ready: "green", collected: undefined, cancelled: "red",
};
export const JobStatusBadge = ({ s }: { s: string }) => <Badge tone={JOB_TONE[s as JobStatus]}>{JOB_STATUS_LABEL[s as JobStatus] ?? s}</Badge>;

const QUOTE_TONE: Record<string, Tone> = { draft: undefined, sent: "blue", accepted: "green", declined: "red", expired: "amber", cancelled: "red" };
export const QuoteStatusBadge = ({ s }: { s: string }) => <Badge tone={QUOTE_TONE[s]}>{QUOTE_STATUS_LABEL[s as keyof typeof QUOTE_STATUS_LABEL] ?? s}</Badge>;

const BOOKING_TONE: Record<string, Tone> = { requested: "amber", confirmed: "blue", arrived: "green", cancelled: "red", no_show: "red" };
export const BookingStatusBadge = ({ s }: { s: string }) => <Badge tone={BOOKING_TONE[s]}>{BOOKING_STATUS_LABEL[s as keyof typeof BOOKING_STATUS_LABEL] ?? s}</Badge>;

const ENQ_TONE: Record<string, Tone> = { new: "red", contacted: "blue", quoted: "navy", booked: "green", closed: undefined, spam: undefined };
export const EnquiryStatusBadge = ({ s }: { s: string }) => <Badge tone={ENQ_TONE[s]}>{ENQUIRY_STATUS_LABEL[s as keyof typeof ENQUIRY_STATUS_LABEL] ?? s}</Badge>;

export const DeptBadge = ({ d }: { d: string | null | undefined }) => d ? <Badge tone={d === "bodywork" ? "red" : "navy"}>{DEPARTMENT_LABEL[d as "mechanical"] ?? d}</Badge> : null;

const SETTLEMENT_TONE = { void: "red", unpaid: "red", part_paid: "amber", part_credited: "amber", paid: "green", credited: "blue" } as const;
/** Invoice status from payments and credit notes. A fully credited invoice shows "Credited", never "Paid". */
export function InvoiceStatus({ status, total, paid, credited }: { status: string; total: number; paid: number; credited: number }) {
  const s = invoiceSettlement({ status, totalPence: total, paidPence: paid, creditedPence: credited });
  return <Badge tone={SETTLEMENT_TONE[s]}>{INVOICE_SETTLEMENT_LABEL[s]}</Badge>;
}

export const date = formatDateUK;
export function dateTime(iso: string | null | undefined) {
  if (!iso) return "—";
  return new Intl.DateTimeFormat("en-GB", { timeZone: "Europe/London", dateStyle: "short", timeStyle: "short" }).format(new Date(iso));
}
export const poundsInput = (p: number | null | undefined) => (p === null || p === undefined ? "" : penceToPoundsString(p));
export function qtyLabel(milli: number) {
  return milli % 1000 === 0 ? String(milli / 1000) : (milli / 1000).toString();
}
